import { SignupContext } from '@jetshop/core/components/Auth/signup-context';
import Input from '../../Forms/Input';
import React, { useContext } from 'react';
import t, { Intl } from '@jetshop/intl';

export const ValidatePID = (value, code) => {
  let error;
  if (!value) {
    error = t('Required');
    return error;
  }

  // Regex checks for format
  let formatValid = false;
  let birthdate;

  if (code === 'SE' && /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{4}$/.test(value)) {
    formatValid = true;
    birthdate = value.substring(0, 8);
  } 
  // if (code === 'FI' && /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])\d{2}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/.test(value)) {
  //   formatValid = true;
  //   birthdate = value.substring(0, 6);
  // } 
  // if ((code === 'NO' || code === 'DK' || code === 'FI') && /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])\d{2}$/.test(value)) {
  //   formatValid = true;
  //   birthdate = value;
  // }
  if ((code === 'NO' || code === 'DK' || code === 'FI') && /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/.test(value)) {
    formatValid = true;
    birthdate = value;
  }
  if (code === 'NL' && /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/.test(value)) {
    formatValid = true;
    birthdate = value;
  }

  if (!formatValid) {
    error = t('Invalid format');
    return error;
  }

  // Calculate age from birthdate
  const calculateAge = (birthDateString, code) => {
    let today = new Date();
    let birthDateComponents;
    let birthDate;
  
    // if (code === 'FI' || code === 'NO' || code === 'DK') {
    //   // Finnish social security number format DDMMYY
    //   birthDateComponents = birthDateString.match(/^(\d{2})(\d{2})(\d{2})/).slice(1);
    //   let yearPrefix = (parseInt(birthDateComponents[2], 10) > today.getFullYear() % 100) ? '19' : '20';
    //   birthDate = new Date(`${yearPrefix}${birthDateComponents[2]}-${birthDateComponents[1]}-${birthDateComponents[0]}`);
    // } else {
      // Other formats assumed to be YYMMDD
      birthDateComponents = birthDateString.match(/^(\d{2})(\d{2})(\d{2})/).slice(1);
      let yearPrefix = (parseInt(birthDateComponents[0], 10) > today.getFullYear() % 100) ? '19' : '20';
      birthDate = new Date(`${yearPrefix}${birthDateComponents[0]}-${birthDateComponents[1]}-${birthDateComponents[2]}`);
    
  
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
  
    // Adjust for ages above 100 by assuming a 21st-century birth year
    if (age > 100) {
      let century = '20';
      birthDate = new Date(`${century}${birthDateComponents[2]}-${birthDateComponents[1]}-${birthDateComponents[0]}`);
      age = today.getFullYear() - birthDate.getFullYear();
      m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
    }
  
    return age;
  };
  
  

  const age = calculateAge(birthdate, code);
  const minAge = code === 'NL' ? 18 : 16;
  
  if (age < minAge) {
    error = code === 'NL' ? t('Must be 18 or older') : t('Must be 16 or older');
  }

  return error;
};

export function PID({ currentCountryCode }) {
  const { allFields } = useContext(SignupContext);

  const pid = allFields.find(
    field => field.id === 'pid' || field.id === 'organizationNumber'
  );

  if (!pid) return null;
  return (
    <Intl>
      {t => (
        <Input
          type={pid.type}
          name={pid.name}
          label={currentCountryCode === 'NO' ? 'Fødselsdato' : pid.label}
          required={true}
          placeholder={t('YYYYMMDD')}
          validate={(value) => ValidatePID(value, currentCountryCode)}
        ></Input>
      )}
    </Intl>
  );
}
